// extracted by mini-css-extract-plugin
export default {"root":"Video_root__TnQM2"};